var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { class: { center: _vm.center } }, [
    !_vm.editingName
      ? _c(
          "span",
          {
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.edit()
              }
            }
          },
          [
            _vm._v("\n        " + _vm._s(_vm.name) + "  \n        "),
            !_vm.locked
              ? _c("i", {
                  staticClass: "fa fa-pencil mdb-icon-btn edit",
                  style: _vm.style
                })
              : _vm._e()
          ]
        )
      : _c("span", [
          !_vm.textArea
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newName,
                    expression: "newName"
                  }
                ],
                ref: "input",
                class: _vm.inputClasses,
                attrs: { maxlength: _vm.maxLength, type: "text" },
                domProps: { value: _vm.newName },
                on: {
                  blur: function($event) {
                    return _vm.rename()
                  },
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.rename()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.newName = $event.target.value
                  }
                }
              })
            : _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newName,
                    expression: "newName"
                  }
                ],
                ref: "input",
                class: _vm.inputClasses,
                attrs: { wrap: "off", autofocus: "", maxlength: _vm.maxLength },
                domProps: { value: _vm.newName },
                on: {
                  blur: function($event) {
                    return _vm.rename()
                  },
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newName = $event.target.value
                    },
                    _vm.resize
                  ]
                }
              })
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }